export default __webpack_public_path__ + "static/media/placeholder_dummy2016-streetfashion01-de.d8db58f2.png";